import { KeyFinding } from "../types";
import { SECTION_TITLE } from "./config";

function normalize(f: KeyFinding | string): KeyFinding {
  return typeof f === "string" ? { title: "", text: f } : f;
}

export function KeyFindings({ findings }: { findings: (KeyFinding | string)[] }) {
  if (findings.length === 0) return null;

  return (
    <div>
      <h2 className={`${SECTION_TITLE} mb-3`}>Key Findings</h2>
      <ul className="flex flex-col gap-2 pl-1">
        {findings.map((raw, i) => {
          const f = normalize(raw);
          return (
            <li key={i} className="flex items-start gap-2 text-sm text-foreground leading-snug">
              <span className="mt-1.5 size-1.5 rounded-full bg-foreground shrink-0" />
              <span>
                {f.title && <span className="font-semibold">{f.title}: </span>}
                {f.text}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
